module.exports = __webpack_public_path__ + "img/discountPriceBgc.d0f6bd40.svg";